export default __webpack_public_path__ + "static/media/microchip-green.a4bfdebe.svg";